/**
 *
 * @module sku
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    string,
    nonEmptyString,
    nonEmptyObject,
    array
} = Check.assert;

/**
 *
 * @class Sku
 *
 */
export default class Sku {

    /**
     *
     * @param {Object} options
     * @param {String} options.name
     * @param {String} options.billingType
     * @param {String} options.productDescription
     * @param {String} options.currency
     * @param {?String} [options.productType]
     * @param {Array<String>} options.categories
     * @throws {InvalidArgumentException}
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: 'Sku(options)',
            get options() {
                return `${this.ctor} options should be a non-empty Object`;
            },
            get name() {
                return `${this.ctor} options.name should be a String with length`;
            },
            get billingType() {
                return `${this.ctor} options.billingType should be a String with length`;
            },
            get productDescription() {
                return `${this.ctor} options.productDescription should be a String with length`;
            },
            get currency() {
                return `${this.ctor} options.currency should be a String with length`;
            },
            get productType() {
                return `${this.ctor} options.productType should be a String`;
            },
            get categories() {
                return `${this.ctor} options.categories should be an Array of Strings`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { name, billingType, productDescription, currency, productType, categories } = options;

        nonEmptyString(name, errorMessage.name, InvalidArgumentException);
        nonEmptyString(billingType, errorMessage.billingType, InvalidArgumentException);
        nonEmptyString(productDescription, errorMessage.productDescription, InvalidArgumentException);
        nonEmptyString(currency, errorMessage.currency, InvalidArgumentException);

        if (Check.assigned(productType)) {
            string(productType, errorMessage.productType, InvalidArgumentException);
        }

        array.of.string(categories, errorMessage.categories, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.name = name;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.billingType = billingType;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.productDescription = productDescription;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.currency = currency;

        /**
         *
         * @access public
         * @type {String|undefined|null}
         *
         */
        this.productType = productType;

        /**
         *
         * @access public
         * @type {Array<String>}
         *
         */
        this.categories = categories;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/sku.js